export const BRAND = "#EF4277";
export const BRAND_LIGHT = "#FDE8EF";
export const BRAND_DARK = "#BE1E53";

export const JOB_FIELD_OPTIONS = [
  { key: "workType", label: "Work Type" },
  { key: "location", label: "Location" },
  { key: "salary", label: "Salary" },
  { key: "category", label: "Category" },
  { key: "startDate", label: "Start Date" },
  { key: "duration", label: "Duration" },
  { key: "summary", label: "Job Summary" },
  { key: "ownerName", label: "Owner Name" },
  { key: "ownerEmail", label: "Owner Email" },
  { key: "ownerMobile", label: "Owner Mobile" },
  { key: "ownerPhone", label: "Owner Phone" },
  { key: "ownerJobTitle", label: "Owner Job Title" },
  { key: "button", label: "View More Button" }
];

export const JOB_SEARCH_BY_OPTIONS = [
  { key: "jobTitle", label: "Title", placeholder: "Search by job title…" },
  { key: "jobId", label: "ID", placeholder: "Enter job ID…" },
  {
    key: "jobCompanyName",
    label: "Company",
    placeholder: "Search by company…"
  },
  { key: "statusName", label: "Status", placeholder: "Search by status…" },
  { key: "categoryName", label: "Category", placeholder: "Search by category…" }
];

export const JOB_DATA_FILTER_OPTIONS = [
  { key: "hasSalary", label: "Has Salary" },
  { key: "hasOwner", label: "Has Owner" },
  { key: "hasSummary", label: "Has Summary" },
  { key: "hasDuration", label: "Has Duration" }
];
